import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * About Page Component
 * Features:
 * - Hero section
 * - Story section
 * - Why Choose Us grid
 */
const About = () => {
  const { t } = useLanguage();

  const whyChooseUs = [
    { id: 'primeLocation', icon: '📍' },
    { id: 'elegantRooms', icon: '🏨' },
    { id: 'hospitality', icon: '🤝' },
    { id: 'deliciousBreakfast', icon: '🍳' },
    { id: 'easyAccessibility', icon: '🚇' },
  ];

  return (
    <main className="pt-10 sm:pt-14">
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center bg-cover bg-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(26, 26, 46, 0.7), rgba(26, 26, 46, 0.7)), url('${process.env.PUBLIC_URL}/inc/images/bg.webp')`,
        }}
      >
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold drop-shadow-lg text-center px-4">
          {t('about.heroTitle')}
        </h1>
      </section>

      {/* Story Section */}
      <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-navy mb-6 sm:mb-8">
            {t('about.storyTitle')}
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            {t('about.storyText')}
          </p>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-navy mb-12 sm:mb-16 text-center">
            {t('about.whyChooseUsTitle')}
          </h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 sm:gap-8">
            {whyChooseUs.map((item) => (
              <div
                key={item.id}
                className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 text-center"
              >
                <div className="text-5xl sm:text-6xl mb-4">{item.icon}</div>
                <h3 className="text-xl sm:text-2xl font-bold text-primary-navy mb-3">
                  {t(`about.${item.id}.title`)}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  {t(`about.${item.id}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;

